import React from 'react';
import { sections } from '../data/sections';
type PortfolioSectionProps = {
  id: string;
  children: React.ReactNode;
};
export function PortfolioSection({
  id,
  children
}: PortfolioSectionProps) {
  const section = sections.find(s => s.id === id);
  return <section id={id} aria-labelledby={`${id}-title`} className="scroll-mt-20 border-t border-rule bg-white py-20 md:py-24" data-id="element-161" data-mp="j13embqp55tb">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-[4.5rem]" data-id="element-162" data-mp="1br28qljqzt4u">
        <header className="mb-12 max-w-3xl" data-id="element-163" data-mp="1bpr5qny4mpes">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-wheat-dark" data-id="element-164" data-mp="1gpn8kjv38asr">{section?.label}</p>
          <h2 id={`${id}-title`} className="mt-5 font-serif text-4xl font-bold leading-tight text-forest md:text-5xl" data-id="element-165" data-mp="11smh8hgt6hut">
            {section?.title}
          </h2>
          {section?.intro && <p className="mt-5 text-lg leading-relaxed text-charcoal" data-id="element-166" data-mp="3mjdexl4rrufs">{section.intro}</p>}
        </header>
        {children}
      </div>
    </section>;
}